import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateIglooPin } from './get-igloo-pin'

const revokeIglooPin = async (clientId: string) => {
  const response = await authAPI.delete(`/igloowork/${clientId}/pin`)
  return response.data
}

export const useRevokeIglooPin = (clientId: string) => {
  const invalidate = useInvalidateIglooPin(clientId)
  return useMutation({
    mutationFn: () => revokeIglooPin(clientId),
    onSuccess: invalidate,
  })
}
